import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
        >
            {props.title && <title>{props.title}</title>}
            
            <path d="M16.9875 0H20.2969L13.0688 8.25937L21.5719 19.5H14.9156L9.69844 12.6844L3.73594 19.5H0.421875L8.15156 10.6641L0 0H6.825L11.5359 6.22969L16.9875 0ZM15.825 17.5219H17.6578L5.82656 1.875H3.85781L15.825 17.5219Z" 
                fill="currentColor"/>
       </svg>
    );
};

export default React.memo(Twitter);
